<template>
  <ob-client-section type="oraseClient" label="Header_3">
  </ob-client-section>
</template>

<script>
import ClientSection from '@/components/ClientSection'

export default {
  name: 'orase-client',
  components: {
    'ob-client-section': ClientSection
  },
  data: () => ({
    type: 'oraseClient'
  }),
  created () {
    this.$store.dispatch(`${this.type}/setEventWatchers`)
    this.$store.dispatch(`${this.type}/fetchItems`)
  }
}
</script>

<style>

</style>
